import { ColorTokens } from '../types';
import ColorTokensContext from './ColorTokensContext';

interface ColorTokensProviderProps {
  children: React.ReactNode;
  colorTokens: ColorTokens;
}

const ColorTokensProvider = ({
  children,
  colorTokens,
}: ColorTokensProviderProps) => {
  return (
    <ColorTokensContext.Provider value={colorTokens}>
      {children}
    </ColorTokensContext.Provider>
  );
};

export default ColorTokensProvider;
